<template>
  <div>
    <Header2022 :navbg='true'></Header2022>
    <div class="relatives-wrap">
      <div class="content" v-if="home_owners && home_owners.length>0">
        <div class="home-owner" v-for="(home_owner,index) in home_owners" :key="index">
          <div class="house-wrap" @click="vrTap(home_owner.house_info)">
            <div class="house-img" >
              <img :src="home_owner.house_info.image" mode="aspectFit">
            </div>
            <div class="house-infor">
              <div class="house-address">
                <i>{{home_owner.housing_estate}}</i>
                <i>{{home_owner.floor_num}}</i>
                <i>{{home_owner.house_num}}</i>
              </div>
              <div class="house-type">
                {{home_owner.house_info.name}}
              </div>
            </div>
          </div>
          <div class="owner-wrap">
            <div class="avatar">
              <img :src="home_owner.home_owner_avatar" mode="aspectFill">
            </div>
            <div class="top-details">
              <div class="name">{{home_owner.name}}<i class="ownerTag">业主</i></div>
              <div class="tell">{{home_owner.telephone}}</div>
            </div>
          </div>
          <div v-if="home_owner.relatives && home_owner.relatives.length>0">
            <div class="relative-wrap" v-for="(relativesItem,relativesIndex) in home_owner.relatives"
              :key="relativesIndex">
              <div class="avatar">
                <img :src="relativesItem.avatar" mode="aspectFill">
              </div>
              <div class="details">
                <div class="detailsTop">
                  <div class="name">{{relativesItem.name}}<i class="relativeTips">{{relativesItem.relatives}}</i></div>
                </div>
                <div class="tell">{{relativesItem.telephone}}</div>
                <div class="date">{{relativesItem.date_added}}</div>
              </div>
              <div class="btn" @click="removeBindTap(relativesItem,home_owner.is_homerowner)"
                :class="(home_owner.is_homerowner == 0 && (relativesItem.customer_id != user_info.customer_id)) ? 'gray' : ''">
                <i class="btnTitle">解除关系</i>
              </div>
            </div>
          </div>
          <div class="scan-add" v-if="home_owner.is_homerowner != 0">
            添加亲友请到邻里小程序
          </div>
        </div>
      </div>
      <div class="content" v-else>
        <div class="tip">{{prompt}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import Header2022 from '@/components/header2022.vue'
  import utils from '@/common/utils'

  export default {
    data() {
      return {
        home_owners: [],
        prompt: '您还没有亲属哦，快去小程序绑定吧！',
      }
    },
    components: {
      Header2022,
    },
    computed: {
      ...mapState(['user_info', 'ocApi', 'access_token']),
      bntStyle() {
        let bntStyle = {
          fontSize: '34div',
          width: '300px',
          textAlign: 'center',
          backgroundImage: 'linear-gradient(90deg,#01CCF6 0%,#10EA8D 100%)',
          color: '#fff',
          height: '88px'
        };
        return bntStyle;
      }
    },
    created() {
      this.getRelativesList();
    },
    methods: {
      vrTap(house_info) {
        if (!house_info.product_id) {
          return false;
        }
        if (house_info.is_vr_more > 0) {
          this.$router.push({
            name: 'vrList',
            query: {
              id: house_info.product_id,
              vr_type: 'product_id',
            }
          });
        } else {
          window.open(house_info.vr_url, "_blank");
        }
      },
      getRelativesList: function() {
        this.$axios.get(this.ocApi + 'homeowner/house_list')
          .then(res => {
            if (res.data.status == 1) {
              this.home_owners = res.data.data.home_owner_list;
            } else if (res.data.status == 0) {
              this.home_owners = [];
              this.prompt = '您没有被业主绑定为亲友哦';
            } else {
              uni.showToast({
                title: res.data.message,
                icon: 'none',
                duration: 3500
              });
            }
          })
          .catch(error => {
            this.$message.error(error.response.data.message);
          });
      },
      removeBindTap: utils.debounce(function(item, is_homerowner) {
        let that = this;
        var id = item.home_relatives_id;
        var customer_id = item.customer_id;
        if (customer_id != that.user_info.customer_id && is_homerowner == 0) {
          return false;
        }
        that.$confirm('您确定要解除关系吗？', '解绑提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.removeConfirm(id);
        })
      }, 500, true),
      removeConfirm(id) {
        this.$axios.post(this.ocApi + 'homeowner/remove_relatives', {
            id
          })
          .then(res => {
            this.$message({
              type:res.data.status===1?'success':'info',
              message: res.data.message,
            });
            if (res.data.status == 1) {
              this.getRelativesList()
            }
          })
          .catch(error => {
            this.$message.error(error.response.data.message);
          });
      }
    }
  }
</script>
<style lang="scss" scoped>
  // .relatives-wrap{
  //    display: flex; 
  //   justify-content: space-between; 
  //   width: 100%; /* 容器宽度100% */ 
  //   padding: 20px; /* 可选，增加一些内边距 */ 
  //   box-sizing: border-box; /* 使得padding和border包含在width内 */ 
    
  // }
  .content {
    width: 638px;
    margin: 120px auto 50px;
    display: flex;
    flex-direction: column;
    padding: 0 28px;
    
    .tip{
      text-align: center;
      margin: 100px 0;
      font-size: 32px;
    }
    .home-owner {
      width: 100%;
      padding: 12px 12px 25px;
      box-sizing: border-box;
      background-color: #76CEC0;
      border-radius: 10px;
      margin-bottom: 11px;
      .house-wrap {
        width: 100%;
        box-shadow: 0px 0px 24px 6px rgba(221, 221, 221, 0.3);
        margin-bottom: 11px;
        border-radius: 12px 12px 0px 0px;
        cursor: pointer;
        .house-img {
          border-radius: 12px 12px 0px 0px;
          position: relative;
          width: 100%;
          height:246px;
          overflow:hidden;
          img{
            position: absolute; 
            top: 50%; 
            left: 50%; 
            transform: translate(-50%, -50%); /* 注意这里的逗号应该是英文逗号 */ 
            max-width: 100%; 
            height: auto; 
            object-fit: cover; /* 保持原始宽高比并填充容器 */ 
          }
        }

        .house-infor {
          text-align: center;
          padding: 11px 0;
          font-weight: 500;
          color: #000000;
          background-color: #FFFFFF;
          border-radius: 0 0 12px 12px;

          .house-address {
            font-size: 28px;
            line-height: 28px;
            margin-bottom: 20px;

            i {
              margin-right: 5px;
            }
          }

          .house-type {
            font-size: 22px;
            line-height: 22px;
          }
        }
      }

      .avatar {
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        margin-right: 20px;

        img {
          width: 100%;
          border-radius: 50%;
        }
      }

      .owner-wrap {
        width: 100%;
        height: 154px;
        margin: 0 auto;
        box-shadow: 0px 10px 20px 0px rgba(221, 221, 221, 0.3);
        border-radius: 12px;
        background-color: #FFFFFF;
        padding: 30px 0px 0px 30px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;


        .top-details {
          padding: 9px 0 15px 0;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: space-between;

          .name {
            font-size: 28px;
            font-weight: bold;
            line-height: 28px;
            margin-bottom: 15px;

            .ownerTag {
              padding: 3px 7px;
              background: #FC9A05;
              box-shadow: 0px 2px 3px 0px rgba(252, 152, 1, 0.35);
              border-radius: 3px;
              font-size: 14px;
              color: #FFFFFF;
              margin-left: 8px;
              line-height: 14px;
            }
          }

          .tell {
            font-size: 24px;
            line-height: 24px;
          }
        }

      }

      .relative-wrap {
        width: 100%;
        height: 154px;
        margin-top: 11px;
        box-shadow: 0px 0px 24px 6px rgba(221, 221, 221, 0.3);
        border-radius: 12px;
        background-color: #FFFFFF;
        display: flex;
        box-sizing: border-box;
        padding: 0px 0 0px 30px;
        align-items: center;
        position: relative;

        .btn {
          position: absolute;
          right: 10%;
          border-radius: 24px;
          padding: 0 18px;
          height: 38px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          border: 2px solid transparent;
          background-clip: padding-box, border-box;
          background-origin: padding-box, border-box;
          background-image: linear-gradient(90deg, #fff, #fff), linear-gradient(90deg, #10EA8D 0%, #01CBF3 100%);
          cursor: pointer;

          &.gray {
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
            filter: gray;
            filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);

          }

          .btnTitle {
            font-size: 16px;
            line-height: 16px;
          }
        }

        .details {
          .detailsTop {
            .name {
              font-size: 26px;
              font-weight: bold;
              color: rgba(70, 75, 101, 1);
              line-height: 26px;
              margin-right: 18px;

              .relativeTips {
                line-height: 14px;
                padding: 3px 7px;
                background: #F8F8F8;
                border-radius: 3px;
                font-size: 14px;
                color: #949494;
                font-weight: 300;
                margin-left: 8px;
              }
            }
          }

          .tell {
            font-size: 24px;
            color: rgba(70, 75, 101, 1);
            line-height: 24px;
            margin: 13px 0 18px 0;
          }

          .date {
            font-size: 22px;
            color: rgba(167, 169, 179, 1);
            line-height: 22px;
          }
        }
      }
      .scan-add{
        width: 100%;
        text-align: center;
        font-size: 20px;
        line-height: 20px;
        color: #FEFEFE;
        margin: 18px 0 0; 
      }
    }
  }
</style>